<template>
  <Dialog :commonDialog="show" :dialog-width="800">
    <template v-slot:title>
      <div class="d-flex align-center">
        <v-icon left color="cyan">mdi-file-multiple</v-icon>
        Attachments
      </div>
    </template>
    <template v-slot:body>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-list v-if="attachments.length">
              <v-list-item
                v-for="(attachment, index) in attachments"
                :key="index"
                class="mb-2 attachment-item"
              >
                <v-list-item-avatar size="30" class="mr-3">
                  <template v-if="isImage(attachment.extension)">
                    <v-img
                      :src="attachment.file.url"
                      :lazy-src="$assetURL('media/error/empty.png')"
                      class="rounded-lg"
                    ></v-img>
                  </template>
                  <template v-else>
                    <inline-svg
                      class="file-icon"
                      :src="$assetURL(`media/mime/${attachment.extension}.svg`)"
                    />
                  </template>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-600">
                    {{ attachment.name }}

                    <span class="grey--text mt-1 d-flex text-small">{{
                      formatDate(attachment.added_at)
                    }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex align-center mt-1">
                    <v-chip x-small class="mr-2" outlined>
                      {{ attachment.extension.toUpperCase() }}
                    </v-chip>
                    <span class="grey--text">{{
                      formatFileSize(attachment.size)
                    }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="d-flex">
                  <v-btn
                    v-if="allowDownload"
                    icon
                    small
                    color="cyan"
                    class="mr-2"
                    @click="$emit('download', attachment)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="allowPreview && isImage(attachment.extension)"
                    icon
                    small
                    color="primary"
                    @click="$emit('preview', attachment)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="text-center py-8">
              <img
                :src="$assetURL('media/error/empty.png')"
                class="empty-image mb-2"
              />
              <p class="text-subtitle-1 grey--text">No attachments found</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:action>
      <v-btn depressed class="mx-2" @click="$emit('close')"> Close </v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog";
import moment from "moment";

export default {
  name: "AttachmentListModal",
  components: {
    Dialog,
  },
  data() {
    return {
      extensionArray: ["jpg", "png", "gif", "jpeg", "webp", "tiff", "jfif"],
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    attachments: {
      type: Array,
      default: () => [],
    },
    allowDownload: {
      type: Boolean,
      default: true,
    },
    allowPreview: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("DD-MM-YYYY");
    },
    isImage(ext) {
      if (find(this.extensionArray, (row) => row == ext.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },

    formatFileSize(bytes) {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
  },
};
</script>

<style scoped>
.attachment-item {
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 8px !important;
}

.attachment-item:hover {
  background-color: #f5f5f5;
}

.file-icon {
  width: 40px;
  height: 40px;
}

.empty-image {
  width: 120px;
  height: auto;
  opacity: 0.5;
}
</style>
